import { UPDATE_BBC_LOG } from '@common/constants/webSockets'
import { IBBCLog, IBBCLogData } from '@common/interfaces/bbcLog'
import { INote } from '@common/interfaces/notes'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../helpers/redux'
import { IAction } from '../apiMiddleware'
import { ADD_NOTE_SUCCESS, DELETE_NOTE_SUCCESS, UPDATE_NOTE_SUCCESS } from '../notes/actions'
import { insertReply, removeFromTree, updateInTree } from '../notes/threadHelpers'
import * as actions from './actions'

export default combineReducers({
  data: createLoadingDataReducer<IBBCLogData>(
    [actions.LIST_BBC_LOG_REQUEST],
    [UPDATE_BBC_LOG, ADD_NOTE_SUCCESS, DELETE_NOTE_SUCCESS, UPDATE_NOTE_SUCCESS],
    true,
    [actions.HIDE_BBC_LOG],
    null,
    (state, action: IAction) => {
      if (action.type === ADD_NOTE_SUCCESS) {
        const noteData = action.data as INote & { bbcLogId?: string }
        if (noteData.parentId) {
          // Recursive: the parent may be a reply at any depth, not just a
          // top-level log note.
          return {
            ...state,
            data: {
              ...state.data,
              data: state?.data?.data?.map((item) => ({
                ...item,
                notes: insertReply(item.notes, noteData),
              })),
            },
          }
        }

        if (noteData.bbcLogId) {
          return {
            ...state,
            data: {
              ...state.data,
              data: state?.data?.data?.map((item: IBBCLog) => ({
                ...item,
                notes: item.id === noteData.bbcLogId ? [noteData] : item.notes,
              })),
            },
          }
        }

        return state
      }

      if (action.type === UPDATE_NOTE_SUCCESS) {
        const noteData = action.data as INote
        if (noteData.parentId) {
          // Recursive: the edited reply can sit at any depth.
          return {
            ...state,
            data: {
              ...state.data,
              data: state?.data?.data?.map((item) => ({
                ...item,
                notes: updateInTree(item.notes, noteData),
              })),
            },
          }
        }

        return state
      }

      if (action.type === DELETE_NOTE_SUCCESS) {
        const noteData = action.data as INote
        if (noteData.parentId) {
          // Recursive, and prunes the deleted reply's own subtree — the server
          // cascades the delete the same way.
          return {
            ...state,
            data: {
              ...state.data,
              data: state?.data?.data?.map((item) => ({
                ...item,
                notes: removeFromTree(item.notes, noteData.id),
              })),
            },
          }
        }

        return state
      }

      // No BBC Logs tab opened
      if (!state.data || !action.data) {
        return state
      }

      const {
        data: { params },
      } = state
      const { data } = action as { data: IBBCLog }
      const { id, clientName } = data

      if (id && Object.keys(data).length === 1) {
        return {
          ...state,
          data: {
            ...state.data,
            data: state.data?.data?.filter((item: IBBCLog) => item.id !== id),
          },
        }
      }

      // Current BBC Logs tab for another Client
      if (clientName !== params.clientName) {
        return state
      }

      return {
        ...state,
        data: {
          ...state.data,
          data: state.data?.data?.find((item: IBBCLog) => item.id === id)
            ? state?.data?.data.map((item: IBBCLog) => (item.id === id ? data : item))
            : [data, ...state.data.data],
        },
      }
    },
  ),
})
